<div class="landing-banner" [class.landing-banner--left]="config.isImageLeft">

    <div class="landing-banner-info">

        @if (config.title) {
        <div class="landing-banner-info-title">
            {{config.title | translate}}
        </div>
        }

        @if (config.subtitle) {
        <div class="landing-banner-info-subtitle">
            {{config.subtitle | translate}}
        </div>
        }

        @if (config.hasButton) {
        <rpc-button class="landing-banner-info-btn" [text]="config.buttonText | translate" [appearanceType]="'flat'"
            [color]="'accent'" (clicked)="onBannerButtonClicked()">
        </rpc-button>
        }

    </div>

    <div class="landing-banner-media" [style.background-image]="'url(' + config.imageUrl + ')'">
    </div>

</div>